import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react'
import { useHistory } from 'react-router';
import Style from './MenuTitle.module.css'
const MenuTitle = (props) => {
    let history = useHistory();
    return (
        <div className={Style.ComponentHolder}>
            <div></div>
            <h3>{props.title}</h3>
            <div onClick={() => history.goBack()}><FontAwesomeIcon style={{fontSize:"1.2rem"}} icon={faArrowRight}/></div>
        </div>
    )
}
export default MenuTitle
